<!--suppress JSNonASCIINames -->
<template>
  <div>
    <!-- 부가정보 : 위험성평가 정보-->
    <div>
      <div class="flex justify-between items-center">
        <h5><i class="dot"></i> 비일상 위험성평가 정보</h5>
        <vs-button v-if="!readonly" color="secondary" @click="popup.form2List = true">비일상 위험성평가 정보 불러오기</vs-button>
      </div>

      <write-grid-container v-model="form.위험성평가정보" :options="위험성평가정보Options" class="mt-28px">
        <template slot-scope="{ index, label, value, dataType }">
          <div v-if="isPrint" class="printing">
            <div v-if="dataType === 'file' && form.위험성평가정보[value]" class="print-input">{{ form.위험성평가정보[value].fileName }}</div>
            <div v-else-if="dataType === 'textarea'" class="print-textarea">{{ form.위험성평가정보[value] }}</div>
            <fragment v-else-if="dataType === 'radio'">
              <PrintRadio v-for="_type in ['직영', '사내수급업체']" :key="`print_${_type}`" :value="form.위험성평가정보[value] === _type" :label="_type" class="justify-center" />
            </fragment>
            <div v-else class="print-input">{{ form.위험성평가정보[value] }}</div>
          </div>

          <div v-else class="write-grid-container-col" :class="dataType === 'double-string' ? 'w-full' : ''">
            <FileUploader v-if="dataType === 'file'" :readonly="readonly" v-model="form.위험성평가정보[value]" />
            <div v-else-if="dataType === 'double-string'" class="flex items-center justify-center gap-2 w-full">
              <p>공장</p>
              <ml-input :readonly="readonly" v-model="form.위험성평가정보[value].공장" class="flex-1" />
              <p>팀</p>
              <ml-input :readonly="readonly" v-model="form.위험성평가정보[value].팀" class="flex-1" />
              <p>공정</p>
            </div>
            <date-selector v-else-if="dataType === 'date'" :readonly="readonly" v-model="form.위험성평가정보[value]" class="w-full" />
            <ml-textarea v-else-if="dataType === 'textarea'" :readonly="readonly" rows="5" v-model="form.위험성평가정보[value]" class="w-full mb-0" />
            <div v-else-if="dataType === 'number'" class="flex items-center justify-center gap-3">
              <NumberInput :readonly="readonly" v-model="form.위험성평가정보[value]" class="w-full" />
              <span>원</span>
            </div>
            <div v-else-if="dataType === 'number2'" class="flex items-center justify-center gap-3">
              <NumberInput :readonly="readonly" v-model="form.위험성평가정보[value]" class="w-full" />
              <span>명</span>
            </div>
            <date-selector-rang v-else-if="dataType === 'daterang'" v-model="form.위험성평가정보[value]" class="w-full" />
            <div v-else-if="dataType === 'radio'" class="radio">
              <vs-radio v-for="_type in ['직영', '사내수급업체']" :key="_type" :disabled="readonly" v-model="form.위험성평가정보[value]" :vs-value="_type" :vs-name="`위험성평가정보_${value}`">{{ _type }}</vs-radio>
            </div>
            <ml-input v-else-if="dataType === 'string'" :readonly="readonly" class="w-full" v-model="form.위험성평가정보[value]" />
          </div>
        </template>
      </write-grid-container>
    </div>

    <!-- 공정분류 -->
    <maot-section title="공정분류" class="mt-28px">
      <template #right>
        <select736-button v-if="!readonly" v-model="form.공정분류.raw" @input="onSelectProcess" />
      </template>
      <div class="col-span-12 writeGridContainer m-0">
        <div>
          <div>대분류</div>
          <div v-if="isPrint" class="print-input">{{ form.공정분류.대분류 }}</div>
          <ml-input v-else v-model="form.공정분류.대분류" :readonly="readonly" />
        </div>
        <div>
          <div>중분류</div>
          <div v-if="isPrint" class="print-input">{{ form.공정분류.중분류 }}</div>
          <ml-input v-else v-model="form.공정분류.중분류" :readonly="readonly" />
        </div>
        <div>
          <div>소분류</div>
          <div v-if="isPrint" class="print-input">{{ form.공정분류.소분류 }}</div>
          <ml-input v-else v-model="form.공정분류.소분류" :readonly="readonly" />
        </div>
        <!--        <div>-->
        <!--          <div>구분</div>-->
        <!--          <div>-->
        <!--            <radio-group flex :items="['정기', '수시']" :readonly="readonly" v-model="form.공정분류.구분">-->
        <!--              <template #수시>-->
        <!--                <custom-option-selector-->
        <!--                  class="flex-1"-->
        <!--                  style="width: 108px"-->
        <!--                  addable-option-->
        <!--                  :readonly="readonly"-->
        <!--                  :isPrint="isPrint"-->
        <!--                  :options="['산재', '설비안전위원회', '투자', '설비 신설', '연료변경', '기타(직접입력)']"-->
        <!--                  v-model="form.공정분류.구분_수시"-->
        <!--                />-->
        <!--              </template>-->
        <!--            </radio-group>-->
        <!--          </div>-->
        <!--        </div>-->

        <div>
          <div>아차사고</div>
          <div>
            <radio-group flex :readonly="readonly" :items="['Y', 'N']" v-model="form.공정분류.아차사고" />
          </div>
        </div>
      </div>
    </maot-section>

    <!-- 작업빈도(횟수) -->
    <h5 class="mt-28px mb-4"><i class="dot"></i> 작업빈도(횟수)</h5>
    <table>
      <thead>
        <tr>
          <th>일</th>
          <th>주</th>
          <th>월</th>
          <th>분기</th>
          <th>년</th>
          <th>1회 작업시간(분)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><ml-input :readonly="readonly" class="w-full" type="number" v-model="form.작업빈도일" /></td>
          <td><ml-input :readonly="readonly" class="w-full" type="number" v-model="form.작업빈도주" /></td>
          <td><ml-input :readonly="readonly" class="w-full" type="number" v-model="form.작업빈도월" /></td>
          <td><ml-input :readonly="readonly" class="w-full" type="number" v-model="form.작업빈도분기" /></td>
          <td><ml-input :readonly="readonly" class="w-full" type="number" v-model="form.작업빈도년" /></td>
          <td><ml-input :readonly="readonly" class="w-full" type="number" v-model="form.작업빈도작업시간" /></td>
        </tr>
      </tbody>
    </table>

    <!-- 부가정보 : 담당-->
    <write-grid-container title="담당" v-model="form.담당" :options="담당Options" class="mt-28px">
      <template slot-scope="{ index, label, value, dataType, placeholder }">
        <div v-if="isPrint" class="printing">
          <div v-if="dataType === 'string'" class="print-input">{{ form.담당[value] }}</div>
          <p v-else></p>
        </div>

        <div v-else class="write-grid-container-col">
          <ml-input v-if="dataType === 'string'" :readonly="readonly" :placeholder="placeholder" class="w-full" v-model="form.담당[value]" />
          <p v-else></p>
        </div>
      </template>
    </write-grid-container>

    <!-- 부가정보 : 동일직무인원 -->
    <write-grid-container title="동일직무인원" v-model="form.동일직무인원" :options="동일직무인원Options" class="mt-28px">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form.동일직무인원[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <div v-if="dataType === 'number'" class="flex items-center justify-center gap-3">
            <NumberInput :readonly="readonly" v-model="form.동일직무인원[value]" class="w-full" :min="0"/>
            <span>명</span>
          </div>
          <ml-input v-else-if="dataType === 'string'" :readonly="readonly" class="w-full" v-model="form.동일직무인원[value]" />
        </div>
      </template>
    </write-grid-container>

    <!-- 위험성평가표 -->
    <maot-section class="mt-28px">
      <template #title>
        위험성평가표
        <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
      </template>
      <table-custom
        class="col-span-12"
        border-x
        customThead
        :board="{ readonly }"
        :controls="!readonly"
        :is-print="isPrint"
        :tableData="위험성평가TableData"
        :mobile="['분류', '원인', '발생빈도', '위험강도', '단위위험', '담당자', '완료예정일']"
        v-model="form.위험성평가표.data"
        @changeEvent="handleSelectorEvent"
        @blurEvent="handleCustomEvent"
      >
        <template #customTitle>
          <div class="writeGridContainer" style="width: 450px">
            <div class="col-span-6">
              <div>위험도</div>
              <div>
                <div class="print-input">{{ form.위험성평가표.위험도 }}</div>
              </div>
            </div>
            <div class="col-span-6">
              <div>중요위험</div>
              <div class="print-input">{{ form.위험성평가표.중요위험 }}</div>
            </div>
          </div>
        </template>
        <template #buttons="{ handleAddButton, handleRemoveButton, checkData }">
          <div class="w-full flex flex-wrap justify-end gap-x-4 gap-y-2">
            <select-risk-assessment-db-button class="w-full sm:w-auto" @select="onSelectRiskDB" />
            <vs-button class="flex-1" color="secondary" @click="handleAddButton"> 항목추가 </vs-button>
            <vs-button class="flex-1" color="secondary" type="border" :disabled="form.위험성평가표.data.length < 1 || checkData.length === 0" @click="handleRemoveButton"> 선택삭제 </vs-button>
          </div>
        </template>
        <template #customHead="{ allCheckValue, onClickAllCheck, mobile, readonly }">
          <fragment v-if="$viewport.isMobile">
            <tr>
              <th v-if="!readonly" style="padding: 6px">
                <div class="p-1 flex justify-center items-center">
                  <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                </div>
              </th>
              <th>분류</th>
              <th>원인</th>
              <th>발생빈도</th>
              <th>위험강도</th>
              <th>단위위험</th>
              <th>담당자</th>
              <th>완료일(예정일)</th>
              <th></th>
            </tr>
          </fragment>
          <fragment v-else>
            <tr>
              <th v-if="!readonly" rowspan="2" class="p-1"><vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox></th>
              <th rowspan="2">분류</th>
              <th rowspan="2">원인</th>
              <th rowspan="2">위험요인</th>
              <th rowspan="2">재해형태</th>
              <th rowspan="2">현재조치 관리상태</th>
              <th rowspan="1" colspan="3">현재 위험도</th>
              <th rowspan="2">감소대책</th>
              <th rowspan="2">담당자</th>
              <th rowspan="2">완료일(예정일)</th>
              <th rowspan="1" colspan="2">적합성검토</th>
            </tr>
            <tr>
              <th>
                <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                  <span>발생빈도</span>
                  <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                </div>
              </th>
              <th>
                <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                  <span>위험강도</span>
                  <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                </div>
              </th>
              <th>
                <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                  <span>단위위험</span>
                  <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                </div>
              </th>
              <th>1차</th>
              <th>2차</th>
            </tr>
          </fragment>
        </template>
        <template #customType="{ row, id, index }">
          <div v-if="id === '분류'" class="">
            <risk-fact-selector :readonly="readonly" v-model="form.위험성평가표.data[index].분류" />
          </div>
          <div v-else-if="id === '원인'" class="">
            <risk-fact-selector :readonly="readonly" v-model="form.위험성평가표.data[index].원인" :분류="form.위험성평가표.data[index].분류 || ' '" />
          </div>
          <div v-else-if="id === '단위위험'" class="">
            <div class="print-input" :style="{ color: getRisk(form.위험성평가표.data[index].발생빈도, form.위험성평가표.data[index].위험강도).color }">
              {{ form.위험성평가표.data[index].단위위험 }}({{ form.위험성평가표.data[index].위험도 }})
            </div>
            <div v-if="form.위험성평가표.data[index].위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
          </div>
        </template>
      </table-custom>
    </maot-section>

    <div class="writeGridContainer mt-28px">
      <div class="writeGridLineItem">
        <div>안전보호구</div>
        <p v-if="isPrint" class="print-input">{{ form.안전보호구 }}</p>
        <ml-input v-else :readonly="readonly" v-model="form.안전보호구" />
      </div>
      <div class="writeGridLineItem">
        <div>정리정돈사항</div>
        <p v-if="isPrint" class="print-input">{{ form.정리정돈사항 }}</p>
        <ml-input v-else :readonly="readonly" v-model="form.정리정돈사항" />
      </div>
      <div class="writeGridLineItem">
        <div>ONE POINT</div>
        <p v-if="isPrint" class="print-input">{{ form.ONEPOINT }}</p>
        <ml-input v-else :readonly="readonly" v-model="form.ONEPOINT" placeholder="단위위험이 제일 큰 내용의 감소대책 또는 현재조치를 참조하여 작성하세요. 예) ~~~좋아!" />
      </div>
      <div class="writeGridLineItem">
        <div>일반작업(Check)</div>
        <p v-if="isPrint" class="print-input">{{ form.일반작업 }}</p>
        <div v-else class="flex items-center h-full">
          <vs-checkbox :disabled="readonly" v-model="form.일반작업">일반 보수정비 작업</vs-checkbox>
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>보충항목(Check)</div>
        <p v-if="isPrint" class="print-input">{{ form.보충항목 }}</p>
        <div v-else class="grid grid-cols-1 xl:grid-cols-6 gap-2">
          <vs-checkbox
            v-for="citem in ['화기 작업', '밀폐공간 작업', '굴착 작업', '고소 작업', '석면해체 작업', '전기 차단작업', '중장비 작업', '방사능 관련 직업', '유해위험방지계획서', '환경영향평가']"
            :key="`보충항목-${citem}`"
            :disabled="readonly"
            :vs-value="citem"
            v-model="form.보충항목"
          >
            {{ citem }}
          </vs-checkbox>
        </div>
      </div>
      <div class="writeGridLineItem">
        <div class="fit-text">환경 RISK검토(Check)</div>
        <p v-if="isPrint" class="print-input">{{ form.환경RISK검토 }}</p>
        <div v-else>
          <div class="flex items-center gap-4 py-3 mb-1" @change="onChangeRisk">
            <vs-radio v-model="form.환경RISK검토해당" :disabled="readonly" vs-name="환경RISK검토" vs-value="해당있음">해당있음</vs-radio>
            <vs-radio v-model="form.환경RISK검토해당" :disabled="readonly" vs-name="환경RISK검토" vs-value="해당없음">해당없음</vs-radio>
          </div>
          <div v-if="form.환경RISK검토해당 === '해당있음'" class="grid grid-cols-1 xl:flex gap-2">
            <vs-checkbox
              v-for="citem in ['신규설비 도입/변경', '화학물질 사용/변경', '오염물질발생(폐기물)', '원·부원료 사용/변경']"
              :key="`보충항목-${citem}`"
              :disabled="form.환경RISK검토해당 === '해당없음' || readonly"
              :vs-value="citem"
              v-model="form.환경RISK검토"
            >
              {{ citem }}
            </vs-checkbox>
          </div>
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>중요위험 해당여부</div>
        <p v-if="isPrint" class="print-input">{{ form.중요위험해당여부 }}</p>
        <div class="flex items-center gap-5 py-3">
          <vs-radio v-model="form.중요위험해당여부" disabled vs-name="중요위험해당여부" vs-value="Y">Y</vs-radio>
          <vs-radio v-model="form.중요위험해당여부" disabled vs-name="중요위험해당여부" vs-value="N">N</vs-radio>
        </div>
      </div>
    </div>

    <popup-risk-dksteel-frequency v-model="popup.빈도" />
    <popup-risk-dksteel-strength v-model="popup.강도" />
    <popup-risk-dksteel-decision v-model="popup.위험도" />

    <popup-load-form2 v-model="popup.form2List" :setBoardId="845" @selectRowData="loadForm2Data"/>
  </div>
</template>

<script>
import WriteGridContainer from "@/components/WriteGridContainer.vue";

import DateSelector from "@/components/selector/DateSelector.vue";
import NumberInput from "@/components/NumberInput.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";
import FileUploader from "@/components/FileUploader.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import TableCustom from "@/components/TableCustom.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";
import SignField from "@/components/SignField.vue";
import MaotSection from "@/components/layout/MaotSection.vue";
import RiskFactSelector from "@/components/selector/riskFactor/RiskFactSelector.vue";
import PopupRiskInfoEp1 from "@/views/project/popup/PopupRiskInfoEp1.vue";
import PopupRiskInfoEp2 from "@/views/project/popup/PopupRiskInfoEp2.vue";
import PopupRiskInfoEp3 from "@/views/project/popup/PopupRiskInfoEp3.vue";
import Select736Button from "@/views/boards/single-page/736/Select736Button.vue";
import PopupRiskDksteelStrength from "@/views/project/popup/PopupRiskDksteelStrength.vue";
import PopupRiskDksteelFrequency from "@/views/project/popup/PopupRiskDksteelFrequency.vue";
import PopupRiskDksteelDecision from "@/views/project/popup/PopupRiskDksteelDecision.vue";
import SelectRiskAssessmentDbButton from "@/views/boards/single-page/830/SelectRiskAssessmentDbButton.vue";
import 유해위험요인 from "@/components/selector/riskFactor/유해위험요인";
import { computeLevenshteinDistance } from "@/util/DataUtil";
import PopupLoadForm2 from "@/views/boards/single-page/845/form2/PopupLoadForm2.vue";

export default {
  components: {
    PopupLoadForm2,
    SelectRiskAssessmentDbButton,
    PopupRiskDksteelDecision,
    PopupRiskDksteelFrequency,
    PopupRiskDksteelStrength,
    Select736Button,
    WriteGridContainer,
    DateSelector,
    NumberInput,
    CustomOptionSelector,
    FileUploader,
    DateSelectorRang,
    TableCustom,
    RadioGroup,
    PrintRadio,
    SignField,
    MaotSection,
    RiskFactSelector,
    PopupRiskInfoEp3,
    PopupRiskInfoEp2,
    PopupRiskInfoEp1,
  },
  props: {
    isPrint: Boolean,
    readonly: { type: Boolean, default: false },
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      hazardFactors: 유해위험요인,
      위험성평가정보Options: {
        dataTypes: ["date", "string", "double-string", "radio"],
        labels: ["평가일자", "공정명", "", "직영/수급업체"],
        values: ["평가일자", "공정명", "공장", "직영협력"],
      },
      담당Options: {
        classes: ["", "", "", "xl:flex"],
        dataTypes: ["string", "", "", "string"],
        labels: ["작성자", "", "", "검토자"],
        values: ["작성자", "", "", "검토자"],
      },
      동일직무인원Options: {
        dataTypes: ["number", "number"],
        labels: ["상주반", "교대반"],
        values: ["상주반", "교대반"],
      },

      // 위험성평가 + 폼2불러오기
      popup: {
        빈도: false,
        강도: false,
        위험도: false,

        form2List: false,
      },
      위험성평가TableData: [
        { id: "분류", title: "분류", type: "customType", width: "132px" },
        { id: "원인", title: "원인", type: "customType", width: "132px" },
        { id: "위험요인", title: "위험요인", type: "textarea", width: "132px", blurEvent: true },
        { id: "재해형태", title: "재해형태", type: "disaster", width: "132px" },
        { id: "현재조치관리상태", title: "현재조치 관리상태", type: "textarea", width: "132px" },
        { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px", changeEvent: true },
        { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px", changeEvent: true },
        { id: "단위위험", title: "단위위험", type: "customType", width: "114px" },
        { id: "감소대책", title: "감소대책", type: "textarea", width: "132px" },
        { id: "담당자", title: "담당자", type: "text", width: "132px" },
        { id: "완료예정일", title: "완료예정일", type: "date", width: "132px" },
        { id: "검토1차", title: "1차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px" },
        { id: "검토2차", title: "2차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px" },
      ],

      form: this.value,
    };
  },
  watch: {
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        this.form = value;
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.위험성평가표.data": {
      deep: true,
      handler(list) {
        if (list && list.length > 0) {
          let sum위험도 = 0
          let is중요위험 = false
          this.is위험도20 = false
          list.forEach((item) => {
            const 발생빈도 = item.발생빈도
            const 위험도 = item.위험도

            sum위험도 += (위험도 ? Number(위험도) : 0)
            if (발생빈도 >= 5 || 위험도 >= 10) {
              is중요위험 = true
            }
            if (위험도 >= 20) {
              this.is위험도20 = true;
            }
          })

          const 위험도점수 = (sum위험도 / list.length).toFixed(1)
          this.form.위험성평가표.위험도 = isNaN(위험도점수) ? "계산중" : 위험도점수;
          this.form.위험성평가표.중요위험 = is중요위험 ? "Y" : "N";
        }
      },
    },
  },
  created() {
    this.form.위험성평가정보 = this.위험성평가정보Options.values.reduce((acc, cur) => {
      if (cur === "공장") acc[cur] = {};
      else acc[cur] = "";
      return acc;
    }, {});
    this.form.담당 = this.담당Options.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});
    this.form.동일직무인원 = this.동일직무인원Options.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});
  },
  methods: {
    validate() {
      if (!this.form.위험성평가정보.평가일자) return "비일상 위험성평가 정보의 평가일자를 입력해주세요.";
      if (!this.form.위험성평가정보.공정명) return "비일상 위험성평가 정보의 공정명을 입력해주세요.";
      if (!this.form.위험성평가정보.공장.공장) return "비일상 위험성평가 정보의 공장을 입력해주세요.";
      if (!this.form.위험성평가정보.공장.팀) return "비일상 위험성평가 정보의 팀을 입력해주세요.";
      if (!this.form.위험성평가정보.직영협력) return "비일상 위험성평가 정보의 직영/수급업체를 입력해주세요.";

      if (!this.form.공정분류.대분류) return "공정분류의 대분류를 입력해주세요.";
      if (!this.form.공정분류.중분류) return "공정분류의 중분류를 입력해주세요.";
      if (!this.form.공정분류.소분류) return "공정분류의 소분류를 입력해주세요.";
      if (!this.form.공정분류.아차사고) return "공정분류의 아차사고를 입력해주세요.";

      if ((!this.form.작업빈도일 || this.form.작업빈도일 <= 0) &&
        (!this.form.작업빈도주 || this.form.작업빈도주 <= 0) &&
        (!this.form.작업빈도월 || this.form.작업빈도월 <= 0) &&
        (!this.form.작업빈도분기 || this.form.작업빈도분기 <= 0) &&
        (!this.form.작업빈도년 || this.form.작업빈도년 <= 0)) {
        return "작업빈도를 최소 하나 이상 입력해주세요.";
      }
      if (!this.form.작업빈도작업시간 || this.form.작업빈도작업시간 <= 0) return "1회 작업시간(분)를 입력해주세요.";

      if (!this.form.담당.작성자) return "담당의 작성자를 입력해주세요.";
      if (!this.form.담당.검토자) return "담당의 검토자를 입력해주세요.";

      // 상주반, 교대반에 인원이 없을수가 있어서 필수목록에서 제거 (25.04.10)
      // if (!this.form.동일직무인원.상주반) return "동일직무인원의 상주반을 입력해주세요.";
      // if (!this.form.동일직무인원.교대반) return "동일직무인원의 교대반을 입력해주세요.";

      if (this.form.위험성평가표.data.length === 0) return "위험성평가표 항목을 추가해주세요.";
      if (this.is위험도20) return "중요위험(허용불가능) 위험도가 있습니다. 즉시 개선하십시오.";

      // 중요위험 이상부터(빈도 5점포함)는 해당 항목만 감소대책 담당자 완료일 필수로 입력 (25.04.16)
      // 845, 813, 814 공통조건
      const isMissing = this.form.위험성평가표.data.some((item) => {
        // 발생빈도 5이상 또는 위험강도 10이상인 항목만 체크
        if (item.발생빈도 >= 5 || item.위험강도 >= 10) {
          // 해당 항목의 감소대책, 담당자, 완료예정일이 없으면 true
          return !item.감소대책 || !item.담당자 || !item.완료예정일;
        }
        // 중요위험이 아닌 항목은 검사하지 않음
        return false;
      });
      if (isMissing) return "중요위험(허용가능) 위험이 있는 항목은 감소대책, 담당자, 완료일을 입력해주세요.";

      if (!this.form.안전보호구) return "안전보호구를 입력해주세요.";
      if (!this.form.정리정돈사항) return "정리정돈사항을 입력해주세요.";
      if (!this.form.ONEPOINT) return "ONE POINT 내용을 입력해주세요.";
      if (this.form.환경RISK검토해당 === "해당있음" && (!this.form.환경RISK검토 || this.form.환경RISK검토.length === 0)) return "환경 RISK검토 항목을 선택해주세요.";
    },
    onChangeRisk() {
      this.form.환경RISK검토 = [];
    },
    getRisk(발생빈도, 위험강도) {
      const 위험도 = parseInt(발생빈도) * parseInt(위험강도);

      if (위험도 >= 20) {
        return {
          name: "중요위험(허용불가능)",
          color: "#EA5455",
        };
      }

      if (위험도 >= 10 || 발생빈도 >= 5) {
        return {
          name: "중요위험(허용가능)",
          color: "#FF9F43",
        };
      }

      return {
        name: "일반",
        color: "#28C76F",
      };
    },
    onSelectProcess(raw) {
      this.form.공정분류.대분류 = raw.대분류;
      this.form.공정분류.중분류 = raw.중분류;
      this.form.공정분류.소분류 = raw.소분류;
    },
    onSelectRiskDB(selectedData) {
      this.form.위험성평가표.data = this.form.위험성평가표.data.filter((item) => item.발생빈도 !== "" || item.위험강도 !== "");
      selectedData.forEach((item) => {
        this.addRiskDBItem(item);
      });
    },
    addRiskDBItem(item) {
      const row = { id: this.form.위험성평가표.data.length + 1 };
      row.분류 = item.위험구분;
      const reason = item.원인;
      row.원인 = reason;

      if (reason) {
        const closestMatch = this.searchCategoryFromReason(reason);
        if (closestMatch) {
          row.분류 = closestMatch.분류;
          row.원인 = closestMatch.원인;
        }
      }
      row.위험요인 = item.위험요인;
      row.재해형태 = "";
      row.현재조치관리상태 = item.현재관리상태 || "";
      row.발생빈도 = Number(item.빈도 || "");
      row.위험강도 = Number(item.강도 || "");
      row.단위위험 = "";
      row.감소대책 = item.감소대책 || "";

      this.form.위험성평가표.data.push(row);
    },
    // 원인 값과 가장 가까운 분류 및 원인을 찾는 함수
    searchCategoryFromReason(reason) {
      if (!reason) return null;

      let closestMatch = null;
      let minDistance = Infinity;

      for (const category of this.hazardFactors) {
        for (const item of category.children) {
          const distance = computeLevenshteinDistance(reason, item.value);

          if (distance < minDistance) {
            minDistance = distance;
            closestMatch = { 분류: category.value, 원인: item.value };
          }
        }
      }

      return closestMatch;
    },
    // 발생빈도, 위험강도 선택시
    handleSelectorEvent(index, data) {
      const 발생빈도 = data.발생빈도 ? Number(data.발생빈도) : 0;
      const 위험강도 = data.위험강도 ? Number(data.위험강도) : 0;
      this.form.위험성평가표.data[index].위험도 = 발생빈도 * 위험강도;
      this.form.위험성평가표.data[index].단위위험 = this.getRisk(발생빈도, 위험강도).name;
    },
    handleCustomEvent(data) {
      const id = data.id;
      const 발생빈도 = data.발생빈도 ? Number(data.발생빈도) : 0;
      const 위험도 = data.위험도;
      const 위험요인 = data.위험요인;

      if (발생빈도 === 5 || 10 <= 위험도) {
        const _fi = this.form.중요위험.findIndex((_fd) => _fd.trId === id);
        if (_fi === -1) this.form.중요위험.push({ id: this.form.중요위험[this.form.중요위험.length - 1].id + 1, trId: id, 위험요인, 개선대책: "" });
        else this.form.중요위험[_fi].위험요인 = 위험요인;
      }
    },
    loadForm2Data(data) {
      if (data && data.post_content) {
        const postContent = JSON.parse(data.post_content)
        const body = postContent.body

        console.log('body', body)

        this.form.위험성평가정보 = body.위험성평가정보
        this.form.공정분류 = body.공정분류
        this.form.작업빈도일 = body.작업빈도일
        this.form.작업빈도주 = body.작업빈도주
        this.form.작업빈도월 = body.작업빈도월
        this.form.작업빈도분기 = body.작업빈도분기
        this.form.작업빈도년 = body.작업빈도년
        this.form.담당 = body.담당
        this.form.동일직무인원 = body.동일직무인원
        this.form.위험성평가표.data = body.위험성평가표.data.map((item)     => {
          return {
            ...item,
            발생빈도: item.발생빈도 ? Number(item.발생빈도) : 0,
            위험강도: item.위험강도 ? Number(item.위험강도) : 0,
          };
        });
        this.form.안전보호구 = body.안전보호구
        this.form.정리정돈사항 = body.정리정돈사항
        this.form.ONEPOINT = body.ONEPOINT
        this.form.일반작업 = body.일반작업
        this.form.보충항목 = body.보충항목
        this.form.환경RISK검토 = body.환경RISK검토
        this.form.환경RISK검토해당 = body.환경RISK검토해당
        this.form.중요위험해당여부 = body.중요위험해당여부
      }

    }
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  &,
  th,
  td {
    font-size: 14px;
    text-align: center;
    background: white;
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    background: #f9f9f9;
    padding: 11px 0;
  }

  td {
    font-weight: 400;
    padding: 7px;
  }
}
</style>
